export const SEMAFORO_META = {
  VERDE: {
    label: 'Al día',
    className: 'bg-emerald-100 text-emerald-800 ring-emerald-200',
    dotClassName: 'bg-emerald-500',
  },
  AMARILLO: {
    label: 'Seguimiento próximo',
    className: 'bg-amber-100 text-amber-800 ring-amber-200',
    dotClassName: 'bg-amber-400',
  },
  NARANJA: {
    label: 'Requiere atención',
    className: 'bg-orange-100 text-orange-800 ring-orange-200',
    dotClassName: 'bg-orange-500',
  },
  ROJO: {
    label: 'Atrasado',
    className: 'bg-red-100 text-red-800 ring-red-200',
    dotClassName: 'bg-red-500',
  },
};

export function getSemaforoFromDays(days) {
  const value = Math.max(0, Number(days) || 0);
  if (value <= 1) return 'VERDE';
  if (value <= 3) return 'AMARILLO';
  if (value <= 5) return 'NARANJA';
  return 'ROJO';
}

export function formatDate(value, includeTime = false) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleString('es-EC', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    ...(includeTime ? { hour: '2-digit', minute: '2-digit' } : {}),
  });
}

export function toLocalDateInput(date = new Date()) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function addCalendarDays(days) {
  const date = new Date();
  date.setHours(12, 0, 0, 0);
  date.setDate(date.getDate() + Number(days || 0));
  return toLocalDateInput(date);
}

export function uniqueBy(items, key) {
  const seen = new Set();
  return items.filter(item => {
    const value = item?.[key];
    if (value === null || value === undefined || seen.has(value)) return false;
    seen.add(value);
    return true;
  });
}
